module.exports = "https://static.energy5.com/_next/static/images/demandBg-c669c7dc556ce7f42200431d38d45488.webp";